import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {AppComponent} from './app.component';
import {AppMainComponent} from './app.main.component';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppMenuComponent implements OnInit {
    app = inject(AppComponent);
    appMain = inject(AppMainComponent);


    model: any[];

    ngOnInit() {
        this.model = [
            {label: 'MENU.DASHBOARD', icon: 'pi pi-home', routerLink: ['/']},
            {label: 'MENU.STRATEGY_LIST', icon: 'pi pi-list', routerLink: ['/strategy-list']},
            {label: 'MENU.ADD_STRATEGY', icon: 'pi pi-plus', routerLink: ['/add-strategy']},
            {label: 'MENU.PORTFOLIO_LIST', icon: 'pi pi-chart-bar', routerLink: ['/portfolio-list']},
            {label: 'MENU.PORTFOLIO', icon: 'pi pi-plus', routerLink: ['/portfolio']},
            {label: 'MENU.PORTFOLIO_SHUFFLE', icon: 'pi pi-sort-amount-down-alt', routerLink: ['/shuffle']},
            {
                label: 'MENU.MARKET', icon: 'pi pi-th-large', items: [
                    {label: 'MENU.MARKET', icon: 'pi pi-th-large', routerLink: ['/market-list']},
                    {label: 'MENU.MARKET_DATA', icon: 'pi pi-th-large', routerLink: ['/market-data']},
                ]
            },
            {
                label: 'MENU.ACCOUNTS', icon: 'pi pi-dollar', items: [
                    {label: 'MENU.TRADESTATION', icon: 'pi pi-user', routerLink: ['/tradestation']},
                    {label: 'MENU.LIVE', icon: 'pi pi-chart-line', routerLink: ['/live']},
                    {label: 'MENU.MARKET_TRADES', icon: 'pi pi-list', routerLink: ['/market-trades']},
                ]
            },
            {
                label: 'Meistertask', icon: 'pi pi-check-square', items: [
                    {label: 'Vseobecne', icon: 'pi pi-check-square', url: ['https://www.meistertask.com/app/project/sIO2I7vQ/vseobecne'], target: '_blank'},
                ]
            },
            {
                label: 'MENU.AUTOMATION', icon: 'pi pi-box', items: [
                    {label: 'MENU.DP_GENERATOR', icon: 'pi pi-file-excel', routerLink: ['/dp-generator']},
                    {label: 'MENU.DP_FILTER', icon: 'pi pi-filter', routerLink: ['/dp-filter']},
                    {label: 'MENU.SIMPLIFIER', icon: 'pi pi-file', routerLink: ['/ocesavac']},
                    {label: 'MENU.PERFORMANCE_SETTINGS', icon: 'pi pi-cog', routerLink: ['/performance-settings']},
                    {label: 'PVE', icon: 'pi pi-server', url: ['https://pve.zitrochu.sk:8006/'], target: '_blank'},
                ]
            },
            {label: 'MENU.DESIGN_SYSTEM', icon: 'pi pi-palette', routerLink: ['/design-system']},
        ];
    }

    onMenuClick() {
        this.appMain.menuClick = true;
    }
}
